import http from './httpService';
import { apiUrl, sessionTimeoutInMinuets } from '../config.json';

const tokenKey = 'token';
const leadKey = 'lead_id';
const AccountKey = 'converted_id';


// get from session (if the value expired it is destroyed)
export function sessionGet(key) {
  const stringValue = window.sessionStorage.getItem(key);
  if (stringValue !== null) {
    const value = JSON.parse(stringValue);
    const expirationDate = new Date(value.expirationDate);
    if (expirationDate > new Date()) {
      return value.value;
    }
    window.sessionStorage.removeItem(key);
  }
  return null;
}

// add into session
export function sessionSet(key, value, expirationInMin = 10) {
  const expirationDate = new Date(
    new Date().getTime() + 60000 * expirationInMin,
  );
  const newValue = {
    value,
    expirationDate: expirationDate.toISOString(),
  };
  window.sessionStorage.setItem(key, JSON.stringify(newValue));
}
export function getJwt() {
  return sessionGet(tokenKey);
}


export function setLogin(data) {
  sessionSet('login', data, sessionTimeoutInMinuets);
}

export function getLogin() {
  return sessionGet('login');
}

export function getLead() {
  const loginData = getLogin();
  if (loginData) {
    return loginData[leadKey] ? loginData[leadKey]
      : loginData[AccountKey];
  }
  return null;
}
http.setJwt(getJwt());

export async function login() {
  try {
    const { data } = await http.post(apiUrl, { action: 'get_token' });
    loginWithJwt(data.data);
  } catch (ex) {
    return null;
  }
}
export async function fetchAppointments(startTimeStamp) {
  try {
    const { data } = await http.post(apiUrl, {
      action: 'get_appointments',
      token: getJwt(),
      lead_id: getLead(),
      start_timestamp: startTimeStamp,
    });

    return data;
  } catch (ex) {
    return null;
  }
}
export async function setAppointments(event) {
  try {
    const d = {};
    d.target_address = event.target_address;
    d.start_time = event.start_time;
    d.finish_time = event.finish_time;
    d.latitude = event.latitude;
    d.longitude = event.longitude;
    d.mapadore_event_id = event.mapadore_event_id;
    d.target_id = event.target_id;
    d.operator_id = event.operator_id;
    d.action = 'set_appointment';
    d.token = getJwt();
    d.clientId = sessionGet('login').converted_id;
    d.data = sessionGet('login').data;
    // console.log("data is", d);
    if (event.target_id) {
      const { data } = await http.post(apiUrl, d);
      return data;
    }
    return null;
  } catch (ex) {
    return null;
  }
}

export function loginWithJwt(jwt) {
  // sessionStorage.setItem('time', Number(new Date()));
  sessionSet(tokenKey, jwt, sessionTimeoutInMinuets);
  // sessionStorage.setItem(tokenKey, jwt);
}

export function logout() {
  sessionStorage.removeItem(tokenKey);
}


export default {
  login,
  loginWithJwt,
  logout,
  getJwt,
  sessionGet,
  setLogin,
  getLogin,
};

const wrapPromise = (promise) => {
  let status = 'pending';
  let result = '';
  const suspender = promise.then(
    (r) => {
      status = 'success';
      result = r;
    },
    (e) => {
      status = 'error';
      result = e;
    },
  );

  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      } else if (status === 'error') {
        throw result;
      }

      return result;
    },
  };
};

export const getAppointments = (startTimeStamp) =>
  // console.log('startTimeStamp', startTimeStamp);
  // if(startTimeStamp)
  wrapPromise(fetchAppointments(startTimeStamp));
